<script>
import { Bar } from 'vue-chartjs'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import 'chartjs-plugin-piechart-outlabels'
import _cloneDeep from 'lodash/cloneDeep'
import _isNumber from 'lodash/isNumber'
import { mapState } from 'vuex'

export default {
  extends: Bar,

  name: 'BarChartMonth',

  props: {
    monthDatasets: {
      type: Array,
      default: () => []
    },
    chartDatalabels: {
      type: Array,
      default: () => []
    }
  },

  components: { ChartJsPluginDataLabels },

  data () {
    return {
      chartdata: {
        labels: this.chartDatalabels,
        datasets: _cloneDeep(this.monthDatasets)
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: ({ datasetIndex, yLabel }, { datasets }) => {
              const formattedYLabel = this.$util.numberWithCommas(
                _isNumber(yLabel) ? yLabel : 0
              )
              const datasetLabel = datasets[datasetIndex].label

              return `${datasetLabel}: ${formattedYLabel}`
            }
          }
        },
        legend: {
          display: false,
          onClick () {
            return null
          }
        },
        layout: {
          padding: {
            top: 40
          }
        },
        scales: {
          title: {
            color: 'red'
          },
          xAxes: [
            {
              ticks: {
                fontColor: '#B9B9C3',
                fontSize: 12
              },
              gridLines: {
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                fontColor: '#B9B9C3',
                fontSize: 12,
                beginAtZero: true,
                callback: (val) => {
                  return this.$util.shortManNumber(val)
                }
              },
              gridLines: {
                drawOnChartArea: false
              }
            }
          ]
        },
        plugins: {
          datalabels: {
            font: {
              size: 10
            },
            formatter: (val) => {
              return this.$util.numberSymbolFormatter(val)
            },
            color: '#6e6b7b',
            align: 'top',
            anchor: 'end',
            offset: -4,
            clamp: false,
            rotation: -60
          }
        },
        legendCallback: function (chart) {
          const { datasets } = chart.data
          const legendHtml = datasets.map(
            (dataset) =>
              `<div class="legend-item">
                <div class="legend-item__icon" style="background-color: ${dataset.backgroundColor}"></div>
                ${dataset.label}
              </div>`
          )

          return legendHtml.join('')
        }
      }
    }
  },

  mounted () {
    this.addPlugin(ChartJsPluginDataLabels)
    this.renderChart(this.chartdata, this.options)
    const HTML = this.$data._chart.generateLegend()
    this.$emit('generated-legend', HTML)
  },

  watch: {
    monthDatasets: {
      handler (newVal) {
        this.chartdata.datasets = _cloneDeep(newVal)
        this.chartdata.labels = this.chartDatalabels
        this.renderChart(this.chartdata, this.options)
      },
      deep: true
    }
  },

  computed: {
    ...mapState(['currentLanguage'])
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    }
  }
}
</script>
